<template>
  <div class="routermian">
    <!-- <transition name="fade-transform" mode="out-in"> -->
    <!-- <keep-alive :include='topNavMentNames'> -->
    <router-view :key="$route.params.orderId" />
    <!-- </keep-alive> -->
    <!-- </transition> -->
  </div>
</template>
<script>
export default {
  computed: {
    visitedViews () {
      return this.$store.state.tagsView.visitedViews
    }
  },
  watch: {
    visitedViews () {
      const temparr = []
      for (let index = 0; index < this.visitedViews.length; index++) {
        const element = this.visitedViews[index]
        if (element.meta.aliveName !== undefined) {
          temparr.push(element.meta.aliveName)
        }
      }
      this.topNavMentNames = temparr
    }
  },

  data () {
    return {
      topNavMentNames: []
    }
  },
  created () {

  }
}
</script>
<style lang='scss'>
.routermian {
  padding-top: 38px;
  // padding-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/RoutingExport/index.vue